// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as Badge$Showside from "./Badge.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as EditorLayerItem$Showside from "./EditorLayerItem.bs.js";
function NavbarItem(Props) {
  var label = Props.label;
  var children = Props.children;
  var showOpt = Props.show;
  var showLabelOpt = Props.showLabel;
  var onClick = Props.onClick;
  var openLinkInNewTabOpt = Props.openLinkInNewTab;
  var classNameOpt = Props.className;
  var href = Props.href;
  var pixelAdjustmentsOpt = Props.pixelAdjustments;
  var disabledOpt = Props.disabled;
  var hideOnDisableOpt = Props.hideOnDisable;
  var badge = Props.badge;
  var customStyle = Props.customStyle;
  var dataTestId = Props.dataTestId;
  var themeOpt = Props.theme;
  var badgeDataTestId = Props.badgeDataTestId;
  var show = showOpt !== undefined ? showOpt : true;
  var showLabel = showLabelOpt !== undefined ? showLabelOpt : false;
  var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var pixelAdjustments = pixelAdjustmentsOpt !== undefined ? pixelAdjustmentsOpt : "0 0 0 0";
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var hideOnDisable = hideOnDisableOpt !== undefined ? hideOnDisableOpt : false;
  var theme = themeOpt !== undefined ? themeOpt : "transparent";
  var onClick$1 = disabled ? undefined : onClick;
  var href$1 = disabled ? undefined : href;
  var className$1 = Cn.make([className, disabled && hideOnDisable ? CSS$Showside.prefix("opacity-0") : disabled ? CSS$Showside.prefix("opacity-25") : CSS$Showside.prefix("cursor-pointer"), CSS$Showside.prefix("text-inherit text-sm flex-col no-underline relative flex items-center justify-center no-touch-highlight"), CSS$Showside.prefix("w-12 h-12")]);
  var adjustedStyle = {
    margin: pixelAdjustments
  };
  var tmp = {
    className: CSS$Showside.prefix("top-px right-px")
  };
  if (badge !== undefined) {
    tmp.text = badge;
  }
  if (badgeDataTestId !== undefined) {
    tmp.dataTestId = Caml_option.valFromOption(badgeDataTestId);
  }
  var badge$1 = React.createElement(Badge$Showside.make, tmp);
  var bgColor = theme === "light" ? "bg-white" : theme === "transparent" ? "opacity-0" : "bg-black bg-opacity-50";
  var textColor = theme === "dark" ? "text-white" : "";
  var content = React.createElement(React.Fragment, undefined, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute top-1/2 left-1/2 w-12 h-12 transform -translate-x-1/2 -translate-y-1/2 rounded-full", bgColor]))
  }), React.createElement(EditorLayerItem$Showside.make, {
    kind: "navbar-item",
    className: CSS$Showside.prefix(Cn.make(["flex-shrink-0 relative flex items-center justify-center w-12 h-12", textColor])),
    style: adjustedStyle,
    children: null
  }, badge$1, children));
  var render;
  if (href$1 !== undefined) {
    var tmp$1 = {
      children: content,
      href: href$1,
      unstyled: true,
      className: className$1,
      openLinkInNewTab: openLinkInNewTab,
      dataDisabled: disabled
    };
    var tmp$2 = showLabel ? undefined : label;
    if (tmp$2 !== undefined) {
      tmp$1.title = Caml_option.valFromOption(tmp$2);
    }
    if (customStyle !== undefined) {
      tmp$1.style = Caml_option.valFromOption(customStyle);
    }
    if (dataTestId !== undefined) {
      tmp$1.dataTestId = Caml_option.valFromOption(dataTestId);
    }
    if (onClick$1 !== undefined) {
      tmp$1.onClick = Caml_option.valFromOption(onClick$1);
    }
    render = React.createElement(Link$Showside.make, tmp$1);
  } else {
    var tmp$3 = {
      className: className$1,
      title: label
    };
    var tmp$4 = onClick$1 !== undefined ? "link" : undefined;
    if (tmp$4 !== undefined) {
      tmp$3.role = Caml_option.valFromOption(tmp$4);
    }
    var tmp$5 = onClick$1 !== undefined ? 0 : undefined;
    if (tmp$5 !== undefined) {
      tmp$3.tabIndex = Caml_option.valFromOption(tmp$5);
    }
    if (onClick$1 !== undefined) {
      tmp$3.onClick = Caml_option.valFromOption(onClick$1);
    }
    var tmp$6 = {
      dataDisabled: disabled,
      children: React.createElement("div", tmp$3, content)
    };
    if (dataTestId !== undefined) {
      tmp$6.dataTestId = Caml_option.valFromOption(dataTestId);
    }
    render = React.createElement(DataAttribute$Showside.make, tmp$6);
  }
  if (show) {
    return render;
  } else {
    return null;
  }
}
NavbarItem.displayName = "NavbarItem";
var make = NavbarItem;
export { make };
/* react Not a pure module */